import type { EditRecurrenceMenu } from '@devexpress/dx-react-scheduler-material-ui';
import React, { useEffect, useRef, useState } from 'react';

import {
  Card,
  FilteredBackground,
  FlexContainer,
  OverlayContainer,
  InnerModal,
  OuterModal,
} from '../AppointmentForm/Overlay/Overlay.style';

/**
 * Modal for creating/editing/deleting routines
 */
const Overlay = ({
  children,
  ...props
}: EditRecurrenceMenu.OverlayProps & {
  children?: React.ReactNode;
}) => {
  const { visible, onHide } = props;
  const modalRef = useRef<HTMLInputElement>(null);
  const bgRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(visible);

  useEffect(() => {
    function handleClick(event: MouseEvent) {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        onHide();
      }
    }

    document.addEventListener('mousedown', handleClick, false);
    bgRef.current?.addEventListener('transitionend', () => {
      setIsOpen(isOpen);
    });
    return () => {
      document.removeEventListener('mousedown', handleClick, false);
    };
  });

  return visible ? (
    <OverlayContainer isOpen={visible}>
      <FilteredBackground
        ref={bgRef}
        style={{
          opacity: 1,
          transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        }}
      />
      <FlexContainer>
        <OuterModal ref={modalRef} width="auto">
          <Card padding="10px">
            <InnerModal>{children}</InnerModal>
          </Card>
        </OuterModal>
      </FlexContainer>
    </OverlayContainer>
  ) : (
    <div />
  );
};

export default Overlay;
